import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { AlertService } from 'sce-core/components/alerts/alert.service';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { ButtonItem } from '../../button/button.model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { Clause, Condition, SearchCriteria } from '../../search/models/search-filter-model';
import { SearchParams } from '../../search/models/search-params.model';
import { SearchStatus } from '../../search/models/search-status.model';
import { DataTableEditorService } from '../../search/results/data-table-editor.service';
import { SearchService } from '../../search/search.service';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { CustomCellRendererComponent } from '../../components/custom-cell-renderer/custom-cell-renderer.component';

@Component({
    selector: 'app-populate-mbol-popup',
    templateUrl: './populate-mbol-popup.component.html',
    styleUrls: ['./populate-mbol-popup.component.css']
})
export class PopulateMbolPopupComponent {
    public searchService: SearchService;
    public searchParams: SearchParams;
    public searchStatus: SearchStatus;
    public resourceService = this.coreServiceRegistry.resourceService;
    public showLookup: boolean = false;
    public type: string;
    public eventSubject = new Subject<any>();
    public setCount: number = 0;
    public qtyCase: number = 0;
    public grossWeight: number = 0; // gross weight = sum of weight of selected rows
    public cube: number = 0; // cube = sum of cube of selected rows

    constructor(
        private coreServiceRegistry: CoreServiceRegistry,
        private sharedServiceRegistry: SharedServiceRegistry,
        private alertService: AlertService) {
        this.eventSubject = new Subject<any>();
    }

    public initializeComponents(facility: string) {
        const tabledId = 'ddmboltd';
        this.searchParams = this.createLookupParamsForColumn(tabledId);
        this.searchParams.alertService = this.alertService;
        const searchStatus = new SearchStatus();
        this.searchService = this.sharedServiceRegistry.createSearchService(this.searchParams, searchStatus);
        this.searchService.setSearchCriteria(this.createSearchCriteria(facility));
        this.searchStatus = this.searchService.searchStatus;
    }

    protected createLookupParamsForColumn(tableId: string) {
        const searchParams = new SearchParams();
        searchParams.tableId = tableId;
        searchParams.isFullFetch = true;
        searchParams.columnCount = 10;
        const tableConfig: DataTableConfig = new DataTableConfig();
        tableConfig.supportFiltering = true;
        tableConfig.columnRendererMapping['status'] = CustomCellRendererComponent;
        searchParams.dataTableConfig = tableConfig;
        searchParams.actionButtons = [
            new ButtonItem('Consolidate', this.resourceService.get('lbl_consolidate'), 'cbol_populate', 'icon_populate.svg', [])];
        const tableEditor: DataTableEditorService = new DataTableEditorService(this.coreServiceRegistry,
            this.sharedServiceRegistry);
        searchParams.tableEditor = tableEditor;
        return searchParams;
    }

    public createSearchCriteria(facility: string) {
        const defaultSearchCriteria = new SearchCriteria();
        defaultSearchCriteria.conditions = [];
        defaultSearchCriteria.loadDefaultCriteria = false;

        const defaultCondition = this.createSearchCondition(1);
        defaultCondition.isReadOnly = false;
        defaultCondition.isMandatory = true;
        defaultCondition.operator = 'AND';
        const defaultClause = new Clause();
        defaultClause.column = 'facility';
        defaultClause.value = facility;
        defaultClause.operation = '=';
        defaultClause.logicalOperation = '';
        defaultCondition.clauses = [defaultClause];
        defaultSearchCriteria.conditions.push(defaultCondition);
        return defaultSearchCriteria;
    }

    /**
     * create an instance of condition
     * @param id
     */
    protected createSearchCondition(id: any) {
        const defaultCondition = new Condition();
        defaultCondition.id = id;
        defaultCondition.displayMode = 'VIEW';
        return defaultCondition;
    }

    public handleButtonAction($event) {
        // Currently only populate button
        if ($event === 'Consolidate') {
            this.handlePopulateAction();
        }
    }

    public handlePopulateAction() {
        const selectedRows = this.searchService.getSelectedRows();

        if (selectedRows.length === 0) {
            this.alertService.error(this.resourceService.get('msg_sel_detail'));
            return;
        }

        const mBolItems = [];
        selectedRows.forEach((row: any) => {
            mBolItems.push(
                row.cells['mbolKey'].cVal);
        });

        const populateEvent = { 'type': 'populate', 'selectedItems': selectedRows, 'requiredDetailsToPopulateLineItems': mBolItems };
        this.notifyEvent(populateEvent);
    }

    public notifyEvent(value: any) {
        this.eventSubject.next(value);
    }

    public receiveEvent(): Observable<any> {
        return this.eventSubject.asObservable();
    }

    /* event is captured from result data table component on select of checkbox,
    if the row level checkbox is enabled or disabled then the rowIndex also passed */
    public onSelectCheckbox(rowIndex: any) {
        const selectedRows: any[] = this.searchService.getSelectedRows();
        this.setCount = 0;
        this.qtyCase = 0;
        this.grossWeight = 0;
        this.cube = 0;
        if (this.type === 'load' && selectedRows.length > 0) {
            selectedRows.forEach(row => {
                this.setCount += parseInt(row.cells['gohSet'].cVal, 10);
                this.qtyCase += parseInt(row.cells['qtyCase'].cVal, 10);
                this.grossWeight += parseInt(row.cells['weight'].cVal, 10);
                this.cube += parseInt(row.cells['cube'].cVal, 10);
            });
            this.qtyCase = this.qtyCase - this.setCount;
        }
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/populate-mbol-popup/populate-mbol-popup.component.ts